class GoToMultipack extends HTMLElement {
    constructor() {
        super();
        this.multipackLink = this.querySelector("a");
        this.titleSpan = this.querySelector(".js-multipack-title");
        this.textContainer = this.titleSpan?.parentElement;

        if (!this.multipackLink || !this.titleSpan) return;

        this.originalTitle = this.titleSpan.textContent;
        this.baseHandle = this.getBaseHandle(this.dataset.handle);
        this.availablePowers = this.getAvailablePowers(this.dataset.availablePowers);
        this.lowestPowerSlug = this.availablePowers.length ? this.formatPowerSlug(this.availablePowers[0]) : null;

        this._initialized = true;
    }

    connectedCallback() {
        if (!this._initialized) return;

        this.bannerContainer = this.closest("[data-go-to-multipack-container]")
            || this.findLegacyContainer()
            || this;

        this.observeVariantChange();
        this.checkInitialVariant();
    }

    checkInitialVariant() {
        const variantSelects = document.querySelector("variant-selects");
        if (variantSelects && variantSelects.currentVariant) {
            this.handlePowerChange(variantSelects.currentVariant);
        }
    }

    observeVariantChange() {
        if (window.Shopify && window.Shopify.designMode) return;

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event && event.data && event.data.variant) {
                this.handlePowerChange(event.data.variant);
            }
        });
    }

    getBaseHandle(handle) {
        return handle ? handle.replace(/-\d+-\d+$/, "") : "";
    }

    formatPowerSlug(power) {
        return power.replace(".", "-").replace("+", "").trim();
    }

    getAvailablePowers(powers) {
        return powers ? powers.split(",").map(power => power.trim()).sort((a, b) => parseFloat(a) - parseFloat(b)) : [];
    }

    handlePowerChange(variant) {
        if (!variant) return;

        if (variant.available === false) {
            this.hideBanner();
            return;
        }

        const selectedPower = variant.option2 || variant.option1;
        if (!selectedPower) {
            this.hideFallbackMessage();
            return;
        }

        let selectedPowerSlug = this.formatPowerSlug(selectedPower);
        let newMultipackHandle = `${this.baseHandle}-${selectedPowerSlug}`;
        let newMultipackUrl = `/products/${newMultipackHandle}`;

        this.updateMultipackLink(newMultipackUrl, selectedPowerSlug);
    }

    updateMultipackLink(url, selectedPowerSlug) {
        fetch(url, { method: "HEAD" })
            .then(response => {
                if (response.status === 404 || response.url.includes("undefined")) {
                    this.hideBanner();
                } else {
                    this.multipackLink.setAttribute("href", url);
                    this.hideFallbackMessage();
                    this.showBanner();
                }
            })
            .catch(() => {
                this.hideBanner();
            });
    }

    showFallback() {
        if (!this.lowestPowerSlug) return;
        let fallbackHandle = `${this.baseHandle}-${this.lowestPowerSlug}`;
        this.multipackLink.setAttribute("href", `/products/${fallbackHandle}`);
        this.showFallbackMessage();
    }

    showFallbackMessage() {
        this.titleSpan.textContent = "This power isn\'t available — redirecting to closest option.";
        this.titleSpan.style.lineHeight = "1.4";
        if (this.textContainer) {
            this.textContainer.style.height = "auto";
            this.textContainer.style.gap = "4px";
        }
    }

    hideFallbackMessage() {
        this.titleSpan.textContent = this.originalTitle;
        this.titleSpan.style.lineHeight = "";
        if (this.textContainer) {
            this.textContainer.style.height = "";
            this.textContainer.style.gap = "";
        }
    }

    hideBanner() {
        this.bannerContainer.classList.add("tw-hidden");
    }

    showBanner() {
        this.bannerContainer.classList.remove("tw-hidden");
    }

    findLegacyContainer() {
        const parent = this.parentElement;
        if (!parent) return null;

        const classList = parent.classList;
        const isLegacyWrapper = classList.contains("tw-pt-[6px]")
            && classList.contains("tw-pr-[12px]")
            && classList.contains("tw-pb-[6px]")
            && classList.contains("tw-pl-[6px]")
            && classList.contains("tw-bg-[#F5F4F2]");

        return isLegacyWrapper ? parent : null;
    }
}

customElements.define("go-to-multipack", GoToMultipack);
